import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmergencyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emergency"}/>
}
